<template>
  <section id="certification" class="hp-cert">
    <!-- 背景装饰 - 蓝色渐变 + 地球点阵图案，固定在底部 -->
    <div class="hp-cert__deco">
      <!-- 蓝色渐变光晕 -->
      <div class="hp-cert__glow"></div>
      <!-- 地球点阵图片 -->
      <img class="hp-cert__globe" :src="globeImage" alt="" />
    </div>

    <div class="hp-cert__container">
      <!-- 标题 -->
      <div class="hp-cert__head" data-aos="fade-up">
        <h2 class="hp-cert__title">全面的安全体系认证与服务保障</h2>
        <p class="hp-cert__subtitle">
          多年行业数字化建设经验，深入理解行业难点，为企业数字化转型保驾护航
        </p>
      </div>

      <!-- 5 个认证卡片 -->
      <div class="hp-cert__grid" data-aos="fade-up">
        <div v-for="cert in certifications" :key="cert.id" class="hp-cert__card">
          <!-- 认证图标/图片 -->
          <div class="hp-cert__icon">
            <img v-if="cert.image" :src="cert.image" :alt="cert.name" />
            <div v-else class="hp-cert__icon-fallback" :style="{ backgroundColor: `${cert.color}15` }">
              <LucideIcon
                :name="cert.icon"
                :size="32"
                :stroke-width="1.5"
                :style="{ color: cert.color }"
              />
            </div>
          </div>

          <!-- 认证名称 -->
          <h3 class="hp-cert__name">{{ cert.name }}</h3>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
// 对应 projects-vue 的 src/components/sections/CertificationSection.vue
import LucideIcon from '@/components/LucideIcon.vue'

const CERTIFICATIONS = [
  {
    id: 'csee',
    name: '双软认证',
    icon: 'award',
    color: '#2D6FF7',
    image: require('@/assets/homePage/cert-csee.png')
  },
  {
    id: 'high-tech',
    name: '高新技术企业',
    icon: 'shield',
    color: '#E53935',
    image: require('@/assets/homePage/cert-hightech.png')
  },
  {
    id: 'credit-aaa',
    name: '企业信用等级证书（aaa）',
    icon: 'badge-check',
    color: '#1E3A8A',
    image: require('@/assets/homePage/cert-aaa.png')
  },
  {
    id: 'djc',
    name: '网络安全等级保护2.0（三级）',
    icon: 'lock',
    color: '#0D47A1',
    image: require('@/assets/homePage/cert-djc.png')
  },
  {
    id: 'iso',
    name: '质量管理体系认证',
    icon: 'globe',
    color: '#1565C0',
    image: require('@/assets/homePage/cert-iso.png')
  }
]

export default {
  name: 'CertificationSection',
  components: { LucideIcon },
  data() {
    return {
      certifications: CERTIFICATIONS,
      globeImage: require('@/assets/homePage/cert-bg-globe.png')
    }
  }
}
</script>

<style lang="less" scoped>
@import './vars.less';

.hp-cert {
  position: relative;
  .hp-section-padding();
  background: linear-gradient(to bottom, #f0f5ff, #ffffff);
  overflow: hidden;
}

// ---------- 背景装饰 ----------
.hp-cert__deco {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  max-width: 1024px;
  pointer-events: none;
}
.hp-cert__glow {
  position: absolute;
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  width: 100%;
  border-radius: 9999px;
  filter: blur(64px);
  background: linear-gradient(to top, rgba(45, 111, 247, 0.15), rgba(45, 111, 247, 0));

  // aspect-[2/1]
  &::before {
    content: '';
    display: block;
    padding-top: 50%;
  }
}
.hp-cert__globe {
  position: relative;
  display: block;
  width: 100%;
  height: auto;
  max-height: 450px;
  opacity: 0.4;
}

.hp-cert__container {
  .hp-container();
  position: relative;
  z-index: 10;
}

// ---------- 标题 ----------
.hp-cert__head {
  text-align: center;
  margin-bottom: 64px;
}
.hp-cert__title {
  .hp-section-title();
}
.hp-cert__subtitle {
  .hp-section-subtitle();
  max-width: 768px;
}

// ---------- 认证卡片 ----------
.hp-cert__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 24px;

  @media (min-width: @screen-md) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }
  @media (min-width: @screen-lg) {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}
.hp-cert__card {
  background: #fff;
  border-radius: 16px;
  padding: 32px;
  border: 1px solid @hp-border;
}
.hp-cert__icon {
  width: 80px;
  height: 80px;
  margin: 0 auto 16px;
  display: flex;
  align-items: center;
  justify-content: center;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}
.hp-cert__icon-fallback {
  width: 64px;
  height: 64px;
  border-radius: 9999px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.hp-cert__name {
  margin: 0;
  text-align: center;
  font-size: 15px;
  font-weight: 500;
  color: @hp-ink;
  line-height: 1.375;
}
</style>
